/*
Controller: Profile

Operations:
  getProfile
  updateProfile
*/
var Api = require('../config')
var UserProfileDef = require('../definitions/UserProfile')

var Profile = (function () {
  /*
  Operation: getProfile
  Get profile for the current user
  Parameters:
  Responses:
    HTTP 200: UserProfile object
  */
  function getProfileProfile () {
    return new Promise(function (resolve, reject) {
      try {
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var path = '/profile'
      Api
        .request({
          url: path,
          method: 'get'
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: updateProfile
  Update profile for the current user
  Parameters:

  Responses:
    HTTP 200: Settings object
    HTTP 400: In case of SAML user try to update profile
  */
  function updateProfileProfile (bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        UserProfileDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/profile'
      Api
        .request({
          url: path,
          method: 'put',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  var ret = {}
  ret['getProfile'] = getProfileProfile
  ret['updateProfile'] = updateProfileProfile
  return ret
})()

module.exports = Profile
